import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects`}</h2>
    <ProjectCard title="AOSP Extended rom" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
This project is my entry project in android custom rom world.
    </ProjectCard>
    <ProjectCard title="Website for a NGO" link="https://cry.bss.design" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Developed a responsive website for Child Rights and You - CRY.
    </ProjectCard>
    <ProjectCard title="Assistant in python" link="https://github.com/ayushrockzzz/sia_bot" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Developed an assistant in python language which responds to user queries.
    </ProjectCard>
    <ProjectCard title="News reader bot in python" link="https://github.com/ayushrockzzz/news_reader_bot" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
Developed a bot in python which reads news for the user
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      